export const ConfigCountry = {
	isZipCodes: 0,
	international: 1,
	linkWeb: 'webapp.besecret.com',
	siteName: 'Besecret.com',
	domain: 'besecret.com',
};
